export const API_ENDPOINTS = {
    USER: {
      FETCH: '/user/fetch',
      SEARCH: '/user/search',
      GET: '/user/get',
      CREATE: '/user/create',
      UPDATE: '/user/update',
      DELETE: '/user/delete',
    },
    ROLE:{
      FETCH: '/role/fetch',
      FETCHALL: '/role/fetchall',
      SEARCH: '/role/search',
      GET: '/role/get',
      CREATE: '/role/create',
      UPDATE: '/role/update',
      DELETE: '/role/delete',
    }
    }